export default __webpack_public_path__ + "static/DouglasBPM-1ac3086b5bd5dc469f9a6ff5619242af.jpeg";